export default "__VITE_ASSET__DImyZzgl__"